// @flow
import React, { Fragment } from 'react';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';

type Props = {
  isErrored: boolean,
  isValidated: boolean,
  classNames?: string,
};

export const ImageValidationStatus = ({ isErrored, isValidated, classNames }: Props) => {
  return (
    <Fragment>
      {isErrored && (
        <Icon className={classNames} color={COLORS.RED} name={ICONS.CROSS} width="0.625rem" />
      )}
      {isValidated && (
        <Icon className={classNames} color={COLORS.SUCCESS} name={ICONS.CHECK} width="0.625rem" />
      )}
    </Fragment>
  );
};
